/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CloudProvidersEnum = 'AWS' | 'GCP' | 'MOCK' | 'ONPREM';

export const CloudProvidersEnum = {

    AWS: 'AWS' as CloudProvidersEnum,

    GCP: 'GCP' as CloudProvidersEnum,

    MOCK: 'MOCK' as CloudProvidersEnum,

    ONPREM: 'ONPREM' as CloudProvidersEnum
};

